#import "../../../../../email-marketing/graphql-wrappers/graphql/fragments/edition-fragment.graphql"

mutation EditionSendToFilteredList($input: EditionSendToFilteredListInput!) {
    editionSendToFilteredList(input: $input) {
        edition {
            ... on Edition {
                ...EditionFragment
            }
        }
    }
}
